import React from 'react';
import '../assets/css/TestimonialSection.css'; 

const Testimonials = [
    {
        name: 'Sarah M',
        status: 'Daughter of Client',
        testimonial: 'The carers have been absolutely brilliant with my mum. They’re so kind and patient, and they’ve made such a difference to her daily life. It’s a massive relief knowing she’s being properly looked after, especially when I can’t be there.',
        stars: 5
    },
    {
        name: 'John D',
        status: 'Son of Client',
        testimonial: 'I couldn’t be happier with the care my dad’s been getting. The team are so friendly and really go the extra mile to make sure he’s comfortable. It’s made such a difference to him – and to us as a family.',
        stars: 5
    },
    {
        name: 'Emily R',
        status: 'Granddaughter of Client',
        testimonial: 'Having someone come in to look after my nan has been a game changer. She loves chatting with the carers, and they really seem to understand what she needs. It’s taken a lot of stress off me and my mum knowing she’s in good hands.',
        stars: 5
    },
    {
        name: 'Michael W',
        status: 'Son-in-law of Client',
        testimonial: 'The care my mother-in-law gets is spot on. The team are always so helpful and quick to sort out anything we need. She’s been so much happier since they started coming, and we’re all so grateful for the support.',
        stars: 5
    },
];

const TestimonialSectionTwo = () => {
  return (
    <div className="testimonial-section">
      <h2>What people say about us</h2>
      <div className="testimonials-container">
        {Testimonials.map((testimonial, index) => (
          <div key={index} className="testimonial">
            <div className="testimonial-content">
              <div className="testimonial-name">{testimonial.name}</div>
              <div className="testimonial-status">{testimonial.status}</div>
              <div className="testimonial-text">{testimonial.testimonial}</div>
              <div className="testimonial-stars">
                {'★'.repeat(testimonial.stars)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestimonialSectionTwo;
